<template>
  <div class="video-content">
    <!--视频控制-->
    <videoControl />
    <div class="icon-more-content" @click="showVideoChoose" v-click-outside="videoOutside">
      <i class="icon-more"></i>
      <!--本地视频选择-->
      <chooseVideo v-if="showVideo" @close="videoOutside" :showVideo="showVideo"  />
    </div>
  </div>
</template>
<script>
import videoControl from '@/components/local/videoControl';
import chooseVideo from '@/components/local/chooseVideo';
// import Bus from '@/components/doc/bus';
import vClickOutside from 'v-click-outside';
export default {
  name: 'videoContent',
  data() {
    return {
      showVideo: false
    };
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    videoControl,
    chooseVideo
  },
  computed: {},
  methods: {
    showVideoChoose() {
      this.showVideo = true;
    },
    videoOutside() {
      this.showVideo = false;
    },
  }
};
</script>
<style lang="scss" scoped>
.icon-more {
  width: 26px;
  height: 11px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../svg/more_setting.svg');
}
.icon-more-content {
  height: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
}
</style>
